import { Component, Prop, Vue } from 'vue-property-decorator'

import { library } from '@fortawesome/fontawesome-svg-core'
import { faAngleDown } from '@fortawesome/free-solid-svg-icons'
import api from '@/helpers/fetch'

import Loader from '@/components/Loader/index.vue'

library.add(faAngleDown)

@Component({
	components: { Loader },
})
export default class BadgeDecision extends Vue {
	@Prop() readonly item

	get enable() {
		return this.item.groupsRelations.reduce(
			(final, item) => {
				if (item.trial !== null) {
					if (item.trial.closed === null || !item.trial.closed) {
						final.trial = true
					}
				}

				if (item.trialAdm !== null) {
					if (
						item.trialAdm.closed === null ||
						!item.trialAdm.closed
					) {
						final.trialAdm = true
					}
				}
				return final
			},
			{ trial: false, trialAdm: false },
		)
	}

	getDomain() {
		if (window.location.host.includes('localhost:8735')) {
			return 'https://localhost:8735'
		}

		return ''
	}

	getName(user) {
		if (user) {
			const names = user?.name.split(' ')
			const firstName = names[0]
			const lastName = names[names.length - 1]

			return firstName + ' ' + lastName
		}

		return '____'
	}

	activeButton = ''
	async openReport(group, type) {
		this.activeButton = type
		const url =
			type === 'Judicial'
				? '/api/relatorio/' + group.id
				: '/api/relatorio-adm/' + group.id

		const reportType =
			type === 'Judicial'
				? group.reportType
				: group.groupsInfoAdministratives?.[0]?.reportType

		if (reportType.find((item) => item === 'Específico')) {
			const res = await api.get(`/api/reports/${group.id}/${type}`)
			const file = res.reportFiles?.[0]

			if (file) {
				await this.downloadFile(file)
			}
		} else {
			window.open(this.getDomain() + url, '_blank')
		}
	}

	downloading = false
	async downloadFile(file) {
		this.downloading = true
		const googleDriveId = file.googleDriveId
		const res = await fetch(
			'/api/reports/download?googleDriveId=' + googleDriveId,
			{
				headers: {
					Accept: 'application/pdf',
					'Content-Type': 'application/pdf',
				},
				method: 'GET',
				credentials: 'include',
			},
		)

		const headers = [...res.headers]
		const contentDispositionHeader = headers.find(
			(array) => array[0] === 'content-disposition',
		)
		if (contentDispositionHeader) {
			const fileName = contentDispositionHeader[1].replace(
				'attachment; filename=',
				'',
			)

			const blob = await res.blob()
			const newBlob = new Blob([blob])
			const blobUrl = window.URL.createObjectURL(newBlob)

			const link: any = document.createElement('a')
			link.href = blobUrl
			link.setAttribute('download', fileName)
			document.body.appendChild(link)

			if (link) {
				link.click()
				link.parentNode.removeChild(link)
				window.URL.revokeObjectURL(blobUrl)
			}
		}
		this.downloading = false
	}

	getGoogleDriveFolder(item) {
		if (!isNaN(item) && item !== null) {
			return item
		}
		return '_____'
	}
}
